import { render, staticRenderFns } from "./DeliveryStateCards.vue?vue&type=template&id=bda836e4&lang=pug"
import script from "./DeliveryStateCards.vue?vue&type=script&lang=js"
export * from "./DeliveryStateCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports